<script lang="ts" setup>
import { computed } from 'vue'
import { Vue3SlideUpDown } from 'vue3-slide-up-down'

interface Props {
  hideTitle?: boolean
  cardKey?: string
}

const props = defineProps<Props>()
const stateOfActive = useState<boolean>(
  `filter-dropdown-${props.cardKey || Math.random()}-active`,
  () => true,
)
const isActive = computed({
  get() {
    return stateOfActive.value
  },
  set(value: boolean) {
    stateOfActive.value = value
  },
})
</script>

<template>
  <div class="mb-2.5">
    <elements-button
      v-if="!hideTitle"
      :color="{ name: 'primary' }"
      class="filters-dropdown-btn flex !w-full items-center justify-between !px-4 !text-left uppercase"
      @click="isActive = !isActive"
    >
      <slot name="title" />

      <Icon
        mode="css"
        size="32"
        class="-mr-2.5 duration-300"
        name="mdi:chevron-down"
        :class="{
          'rotate-180': isActive,
        }"
      />
    </elements-button>

    <component
      :is="hideTitle ? 'div' : Vue3SlideUpDown"
      v-model="isActive"
      v-bind="hideTitle ? { modelvalue: undefined } : { duration: 400 }"
    >
      <div class="filters-dropdown-content px-3 py-4">
        <slot name="content" />
      </div>
    </component>
  </div>
</template>
